import React, { useContext } from 'react';
import { AuthContext } from 'store/context';
import { Form, Input, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { useWindowSize } from 'react-use';
import classNames from 'classnames';
import { updateUser, hideMessage } from 'store/actions/AuthAction';
import { MIN_MD } from 'constants/ThemeSetting';
import OmiButton from 'components/@Omini/OmiButton';
import BranchIntro from 'components/Auth/BranchIntro';

export default function ForgotPassword() {
  const {
    AuthState: { loading, message, error },
    AuthDispatch,
  } = useContext(AuthContext);

  const { width } = useWindowSize();

  const handleSubmit = async values => {
    await updateUser({ values, dispatch: AuthDispatch });
  };
  const formBtnSumitClasses = classNames({
    'omi-auth-form-submit': true,
    'mt-10 md:mt-16': !error,
  });
  const alertClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': error,
    hidden: !error,
  });
  const alertSuccessClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': message,
    hidden: !message,
  });
  return (
    <div className="flex flex-col lg:flex-row lg:h-auto">
      <div className="omi-auth-layout-title">
        <BranchIntro />
      </div>
      <div className="omi-auth-layout-content">
        <div className="flex lg:h-auto flex-col justify-start items-center m-6 mt-0 sm:mx-40 bg-white lg:justify-start lg:p-0 lg:pt-24 lg:mb-0">
          <div className="omi-auth-form forgot-container">
            <div className="my-10 sm:mt-6 sm:mb-16 lg:mt-0 lg:mb-40">
              <Link to="/login" onClick={() => AuthDispatch(hideMessage())}>
                <img src={require('assets/svg/back.svg').default} alt="back" title="back" />
              </Link>
            </div>
            <div>
              <p className="omi-auth-form-title">Quên mật khẩu?</p>
              <p className="mb-10 lg:mb-8">
                Vui lòng nhập email tài khoản của bạn, chúng tôi sẽ gửi link xác nhận tới email.
              </p>
              <Form
                name="forgotPassword"
                onFinish={handleSubmit}
                size={width >= MIN_MD ? 'large' : 'middle'}
                layout="vertical"
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      type: 'email',
                      message: 'Định dạng email không đúng. Vui lòng kiểm tra lại.',
                    },
                    {
                      required: true,
                      message: 'Yêu cầu nhập email.',
                    },
                  ]}
                >
                  <Input placeholder="hello@omini.com" />
                </Form.Item>
                <Form.Item className={formBtnSumitClasses}>
                  <Alert className={alertClasses} message={error} type="error" showIcon />
                  <Alert className={alertSuccessClasses} message={message} type="success" showIcon />
                  <OmiButton className="w-40" type="primary" htmlType="submit" loading={loading}>
                    Gửi
                  </OmiButton>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
